import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useNavigate } from "react-router-dom";
import Badge from 'react-bootstrap/Badge';
import authApi from "../../Auth/Auth";
import { getUserDetails } from "../../../utils/helper"
//React Icons
import { FaRightToBracket } from "react-icons/fa6";
import { FaAlignLeft } from "react-icons/fa";
import jwt_decode from "jwt-decode";

const Header = (props) => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [loginInfo, setLoginInfo] = useState({});
  
  useEffect(() => {
    if (!localStorage.getItem("token")) navigate("/login");
    try {
      if (localStorage.getItem('token')) {
        let user = getUserDetails();
        setUserInfo(user);
        
      }
    } catch (error) {
      console.log(error)
    }
  }, []);

  const [sidebar, setSidebar] = useState(false);
  const logout = () => {
   // authApi.logout();
    navigate("/");
  };

  const toggleSidebar = () => {
    if (sidebar === false) {
      setSidebar(true);
      document.querySelector("#sidebar").classList.toggle("active");
    }

    else {
      setSidebar(false);
      document.querySelector("#sidebar").classList.toggle("active");

    }

  };

  return (
    <>
      <Navbar className="header px-2" bg="" expand="lg" variant="">
        <button
          type="button"
          id="sidebarCollapse"
          className="btn btn-info"
          onClick={toggleSidebar}

        >
          {/* <i className="fas fa-align-left"></i> */}
          <FaAlignLeft/>
        </button>
        <Navbar.Brand href="#home"></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#" className="p-0" style={{ fontSize: ".9rem" }}>
              <img src={localStorage.getItem("myimage")} className="rounded-circle" style={{ height: "30px" }} />
              <Badge classname="mr-2 ml-2" style={{ fontSize: ".9rem",marginLeft: "9px"}} bg="light" text="dark">{localStorage.username}</Badge>
              {/* {localStorage.getItem("firstname")} */}
              
              {userInfo.userrole === "SUPER_ADMIN" && (
                <Badge bg="success" style={{ fontSize: ".9rem",marginLeft: "12px" }}>Super Admin</Badge>
              )}

              {userInfo.userrole === "ADMIN" && (
                <Badge bg="success" style={{ fontSize: ".9rem",marginLeft: "12px" }}>Admin</Badge>
              )}
              {userInfo.userrole === "USER" && (
                <Badge bg="success" style={{ fontSize: ".9rem",marginLeft: "12px" }}>User</Badge>
              )}
            </Nav.Link>


            {/* New code for module visibility based on user role */}


            <Nav.Link href="#" className="d-flex p-0" style={{ alignItems: "center" }}><span className="mx-2" style={{ fontSize: ".9rem" }}>Company</span> <Badge style={{ fontSize: ".9rem" }} bg="secondary">{userInfo.companyname} </Badge> </Nav.Link>


          </Nav>

          <Nav className="ml-auto">
            {/*<Nav.Link href="/about">
              <i className="fa-solid fa-bell"></i>
              </Nav.Link>*/}
            {localStorage.getItem("token") ? (
              <Button variant="btn btn-primary" onClick={logout} title="Logout">
                {/* <i className="fa-solid fa-right-from-bracket"></i> */}
                <FaRightToBracket />
              </Button>
            ) : (
              <></>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Header;
